import React from 'react';


const ProductoInfo = ({producto}) => {
	if(!producto.categoria){
		return (<h4>CARGANDO...</h4>)
	}
	var Beneficios=""
	var Preguntas=""
	if(producto.categoria.id === 1 || producto.categoria.id === 14 ){
		Beneficios="<h5>Beneficios</h5><ul><li>Disponible en 12 colores</li><li>Adhesivo impermeable: garantizado para permanecer en el agua</li><li>Pestaña adhesiva troquelada segura, inviolable</li><li>Hecho con DuPont ™ Tyvek® fuerte y duradero</li><li>Excelente para uso a corto plazo; conciertos, parques acuáticos, viajes escolares, etc.</li><li>Ajustable a cualquier tamaño de muñeca y cómodo de llevar</li><li>Cada paquete está numerado secuencialmente para una mayor responsabilidad</li><li>Material 100% reciclable</li><li>Impresiones y códigos de barras personalizados disponibles</li><li>Las pulseras fluo son una excelente opción porque que resaltan y se destacan</li></ul><h5>Especificaciones</h5><ul><li>Ancho: 3/4 de pulgada (19 mm)</li><li>Longitud: 10 pulgadas (25 cm)</li><li>Hecho en Argentina</li></ul>"
	}else if(producto.categoria.id === 2 || producto.categoria.id === 13  || producto.categoria.id === 15 ){
		Beneficios="<h5>Beneficios</h5><ul><li>6 colores disponibles</li><li>Uso recomendado: 10 días o más</li><li>Cómodo y ligero</li><li>Resistente al estiramiento y duradero</li><li>Seguro, uso de una sola vez, bloqueo de broches de plástico</li><li>Excelente para un uso prolongado</li><li>Código de barras, numeración personalizada e impresión disponible</li><li>Durable para eventos de uso extendido</li><li>Fabricación a prueba de agua</li><li>Hecho en Argentina</li></ul><h5>Especificaciones</h5><ul><li>Longitud: 10 pulgadas (25 cm)</li><li>Ancho: 5/8 pulgada (16 mm)</li></ul>"
	}else if(producto.categoria.id === 3 ){
		Beneficios="<h5>Beneficios</h5><ul><li>5 colores disponibles</li><li>Uso recomendado: 10 días o más</li><li>Cómodo y ligero</li><li>Resistente al estiramiento y duradero</li><li>Seguro, uso de una sola vez, bloqueo de broches de plástico</li><li>Excelente para un uso prolongado</li><li>Durable para eventos de uso extendido</li><li>Fabricación a prueba de agua</li><li>Hecho en Argentina</li></ul><h5>Especificaciones</h5><ul><li>Longitud: 10 pulgadas (25 cm)</li><li>Ancho: 5/8 pulgada (16 mm)</li></ul>"
	}else if(producto.categoria.id === 26 ){
		Beneficios="<h5>Beneficios</h5><ul><li>13 colores disponibles</li><li>Uso recomendado: 3 - 7 días</li><li>Cómodo y ligero</li><li>Resistente al estiramiento y duradero</li><li>Seguro, uso de una sola vez, bloqueo de broches de plástico</li><li>Excelente para un uso prolongado</li><li>Código de barras, numeración personalizada e impresión disponible</li><li>Durable para eventos de uso extendido</li><li>Fabricación a prueba de agua</li><li>Hecho en Argentina</li></ul><h5>Especificaciones</h5><ul><li>Longitud: 10 pulgadas (25 cm)</li><li>Ancho: 5/8 pulgada (16 mm)</li></ul>"
	}else if(producto.categoria.id === 19 || producto.categoria.id === 5  || producto.categoria.id === 6 ){
		Beneficios=`<h5>Beneficios</h5>
					<ul>
					<li>Disponible en 7 colores</li>
					<li>Hecho en papel y cartulinas de 1ra calidad</li>
					<li>Tintas de seguridad para su imposible falsificacion</li>
					<li>Holograma de seguridad según la calidad</li>
					<li>Tres cuerpos con troquelados  </li>
					<li>Excelente para uso en conciertos, fiestas, discotecas etc</li>
					<li>Cada entrada está numerada secuencialmente para una mayor seguridad</li>
					<li>Material 100% reciclable</li>
					<li>Impresiones y códigos de barras personalizados disponibles</li>
					</ul>
					<h5>Especificaciones</h5>
					<ul>
					<li>Ancho: 52,5 mm </li>
					<li>largo: 152,4 mm</li>
					<li>Hecho en Argentina</li>
					</ul>`
	}else if(producto.categoria.id === 12 || producto.categoria.id === 20 ){
		Beneficios=`<h5>Beneficios</h5>
					<ul>
					<li>Disponible en 1 color</li>
					<li>Hecho en papel termico  de origen aleman</li>
					<li>Tintas de seguridad para su imposible falsificacion</li>
					<li>Holograma de seguridad </li>
					<li>Tres cuerpos con troquelados </li>
					<li>Excelente para uso en conciertos, fiestas, discotecas etc</li>
					<li>Cada entrada está numerada secuencialmente para una mayor seguridad</li>
					<li>Material 100% reciclable</li>
					<li>Impresiones y códigos de barras personalizados disponibles</li>
					</ul>
					<h5>Especificaciones</h5>
					<ul>
					<li>Ancho: 63 mm </li>
					<li>largo: 152,4 mm</li>
					<li>Hecho en Argentina</li>
					</ul>`
	}

	if(producto.categoria.id === 1 || producto.categoria.id === 14 ){
		//Tyvek
		Preguntas=`<div className="row justify-content-center p-5">
			<section className="col-12 col-md-8">
			<article>
			<h5 className="text-info">P. ¿Cuánto duran las pulseras Tyvek®?</h5>
			<p>R. Tendrán una duración de 1 a 2 días.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Cuándo se enviarán o abandonarán mis pulseras sus instalaciones?</h5>
			<p>R. Entregas en Capital Federal, comprando antes de las 14 hs recibis EL MISMO DÍA! Entregas en Gran Buenos Aires, comprando antes de las 14 hs recibis AL DÍA SIGUIENTE! Entregas al interior del pais, despachamos hasta 48 hs a partir del ingreso del pedido. [ dependiendo de la cantidad ] </p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Se pueden transferir?</h5>
			<p>R. ¡NO! Tienen un cierre adhesivo con un troquel cortado que los hace a prueba de manipulaciones. Cuando alguien quita la pulsera, separarán el cierre adhesivo y el troquel cortado sobre el adhesivo asegura que se destruya la pulsera.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Están estos numerados secuencialmente?</h5>
			<p>R. Dentro de cada paquete, sí. Sin embargo, si solicita más de un paquete, no podemos garantizar que sea secuencial.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿De qué tamaño de muñeca caben las pulseras Tyvek®?</h5>
			<p>R. Se adaptarán a los bebés y hasta casi cualquier muñeca.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Puedo escribir en la pulsera?</h5>
			<p>R. Sí, puedes usar un sharpie o un bolígrafo.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Pueden estas pulseras Tyvek® imprimirse con una impresora láser o de inyección de tinta?</h5>
			<p>R. NO recomendamos usar su propia impresora, poner pulseras en su impresora puede ARRUINAR su impresora. Entre otras cosas, se atascan y el adhesivo se puede derretir.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Cómo se empaquetan las pulseras?</h5>
			<p>R. Están empaquetados en hojas de 10.</p>
			</article>
			</section>
		</div>`
	}else if(producto.categoria.id === 2 || producto.categoria.id === 3  || producto.categoria.id === 13  || producto.categoria.id === 15  || producto.categoria.id === 26 ){
		//Plastico
		Preguntas=`<div className="row justify-content-center p-5">
			<section className="col-12 col-md-8">
			<article>
			<h5 className="text-info">P. ¿Cuánto duran las pulseras de plástico?</h5>
			<p>A. Tendrán una duración de 10 días o más.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Cuándo se enviarán o abandonarán mis bandas sus instalaciones?</h5>
			<p>R. Entregas en Capital Federal, comprando antes de las 14 hs recibis AL OTRO DÍA! Entregas en Gran Buenos Aires, comprando antes de las 14 hs recibis A LAS 48 HORAS!  Entregas al interior del pais, despachamos hasta 72 hs a partir del ingreso del pedido. [ dependiendo de la cantidad ]</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Se pueden transferir?</h5>
			<p>R. ¡NO! Tienen un cierre de presión de plástico que debe destruirse para deshacerse.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Están estos numerados secuencialmente?</h5>
			<p>R. No, pero si queres hacé tu pedido personalizado con numeración.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Qué tamaño de muñeca tienen las pulseras plásticas?</h5>
			<p>R. Se adaptarán a los bebés y hasta casi cualquier muñeca.</p>
			</article>

			<article>
			<h5 className="text-info">P. ¿Puedo escribir en la pulsera?</h5>
			<p>R. Sí, puedes usar un sharpie o un bolígrafo.</p>
			</article>
				</section>
		</div>`
	}
	

	return(
	<section className="container-fluid">
	
	<ul className="nav nav-tabs" id="myTab" role="tablist">
		{ Beneficios !== "" &&
	  		<li className="nav-item">
	    		<a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Informacion del Producto</a>
	  		</li>
		}
		
	  	{ Preguntas !== "" &&
	  		<li className="nav-item">
	    		<a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Preguntas Frecuentes</a>
	  		</li>
		}
	</ul>
	<div className="tab-content " id="myTabContent">
	  <div className="tab-pane fade show active " id="home" role="tabpanel" aria-labelledby="home-tab">
		<div className="row justify-content-center p-5">
		<div dangerouslySetInnerHTML={{ __html: Beneficios }} /> 
		</div>
	  </div>

	  <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
		<div dangerouslySetInnerHTML={{ __html: Preguntas }} /> 
	  </div>
	</div>

</section>
)};

export default ProductoInfo;



// WEBPACK FOOTER //
// ./src/components/productoinfo.js